var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanePath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1328,
    height: 493,
    viewBox: "0 0 1328 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1326 489C1154 413 936 533 750 473C592 422.032 587.403 312.587 452 175C328 49.0005 138 -8.99933 -18 5.00036",
    stroke: "url(#paint0_linear_1_107)",
    strokeOpacity: 0.5,
    strokeWidth: 5,
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_107",
    x1: 485.113,
    y1: -67,
    x2: 485.113,
    y2: 593.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#BFBFBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanePath);
export default __webpack_public_path__ + "static/media/plane_path.99b37d22c8156a98eac805515bd842c8.svg";
export { ForwardRef as ReactComponent };